<template>
  <el-dialog title="编辑提货人信息" :visible.sync="isShowInfoDialog" width="440px" height="340px">
    <div class="c-9 f-14">
      <el-row class="m-b15" style="height: 36px; line-height: 36px;">
        <el-col :span="4" class="text-right">
          姓名
        </el-col>
        <el-col :span="16" class="m-l15">
          <el-input
            v-model="pickerInfo.dispatcherName"
            maxlength="500"
            style="width: 300px;"
            placeholder="请输入姓名"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="m-b15" style="height: 36px; line-height: 36px;">
        <el-col :span="4" class="text-right">
          电话
        </el-col>
        <el-col :span="16" class="m-l15">
          <el-input
            v-model="pickerInfo.dispatcherContact"
            maxlength="500"
            style="width: 300px;"
            placeholder="请输入电话"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="m-b15" style="height: 36px; line-height: 36px;">
        <el-col :span="4" class="text-right">
          车牌号
        </el-col>
        <el-col :span="16" class="m-l15">
          <el-input
            v-model="pickerInfo.dispatcherCarNo"
            maxlength="500"
            style="width: 300px;"
            placeholder="请输入车牌号"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="m-b15" style="height: 36px; line-height: 36px;">
        <el-col :span="4" class="text-right">
          身份证
        </el-col>
        <el-col :span="16" class="m-l15">
          <el-input
            v-model="pickerInfo.dispatcherCardNo"
            maxlength="500"
            style="width: 300px;"
            placeholder="请输入身份证号"
          ></el-input>
        </el-col>
      </el-row>
      <el-row style="height: 36px; line-height: 36px;">
        <el-col :span="4" class="text-right">
          其他凭证
        </el-col>
        <el-col :span="16" class="m-l15">
          <el-input
            v-model="pickerInfo.dispatcherParam"
            maxlength="500"
            style="width: 300px; text-left"
            placeholder="提货单号等等"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShowInfoDialog = false">取 消</el-button>
      <el-button type="primary" @click="upInsertDispatcher">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'PickerSectionDialog',
  components: {},
  props: {
    pickerId: Number,
    pickerInfo: {
      type: Object,
      default: () => {
        return {
          dispatcherName: '',
          dispatcherCarNo: '',
          dispatcherContact: '',
          dispatcherCardNo: '',
          dispatcherParam: ''
        }
      }
    },
    getData: Function
  },
  data() {
    return {
      isShowInfoDialog: false
    }
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    async upInsertDispatcher() {
      let isDone = false
      for (const key in this.pickerInfo) {
        this.pickerInfo[key] = this.utf16toEntities(this.pickerInfo[key])
        if (this.pickerInfo[key] !== '' && typeof this.pickerInfo[key] !== 'undefined')
          isDone = true
      }
      if (isDone) {
        let updateFeature = {
          dispatchId: this.pickerId,
          type: 3,
          ...this.pickerInfo
        }
        let { success, data } = await this.$post('lgcenter.updateFeature', {
          updateOrderDepositoryDispatcherInfo: updateFeature
        })
        if (success && data[0].success) {
          this.isShowInfoDialog = false
          this.getData()
        } else {
          this.$message.error(data[0].message)
        }
      } else {
        this.$message.error('请至少填写一项信息！')
      }
    },
    // 转换表情符号及空格
    utf16toEntities(str) {
      if (str) {
        str = str.replace(/[\ud800-\udbff][\udc00-\udfff]/g, '') // 表情替换为?
        str = str.replace(/(^\s*)|(\s*$)/g, '') // 空格取消
        return str
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.picker-section-dialog {
}
</style>
